'use client';

import { sendLandingEvent } from '../../lib/analytics';
import { openGuestFilePicker } from '../../lib/freeStart.mjs';

const labels = {
  en: ['Start free without signup', '3 free transcripts a day. No credit card.'],
  de: ['Kostenlos ohne Anmeldung starten', '3 kostenlose Transkripte pro Tag. Keine Kreditkarte.'],
  fr: ['Commencer gratuitement sans inscription', '3 transcriptions gratuites par jour. Sans carte bancaire.'],
};

export default function FreeStartAction({ locale = 'en', location = 'hero', className = 'btn hero-primary-btn' }) {
  const copy = labels[locale] || labels.en;
  const home = locale === 'en' ? '/' : `/${locale}`;
  return <div className="free-start-action">
    <a href={`${home}#try-transcription`} className={className} data-free-start={location} onClick={event => {
      openGuestFilePicker(event);
      sendLandingEvent('landing_cta_click', { cta_id: `${location}_guest_start`, cta_location: location,
        landing_locale: locale, plan_intent: 'free', offer_variant: 'guest_start_v3' });
    }}>{copy[0]}</a>
    <small>{copy[1]}</small>
  </div>;
}
